import type { DownloadResult } from '@/core/http/client'
import { resolveApiAssetUrl, resolveApiIVUSUrl } from '@/core/http/url'

function readBlobText(blob: Blob) {
  if (typeof blob.text === 'function') return blob.text()
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result || ''))
    reader.onerror = () => reject(reader.error || new Error('下载响应读取失败'))
    reader.readAsText(blob)
  })
}

function filenameFromPath(path: string) {
  const pathname = path.split('#', 1)[0].split('?', 1)[0]
  const filename = pathname.slice(pathname.lastIndexOf('/') + 1)
  if (!filename) return ''
  try {
    return decodeURIComponent(filename)
  } catch {
    return filename
  }
}

export function saveDownload(result: DownloadResult, fallbackFilename = 'download') {
  const objectUrl = URL.createObjectURL(result.blob)
  const anchor = document.createElement('a')
  anchor.href = objectUrl
  anchor.download = result.filename || fallbackFilename
  anchor.style.display = 'none'
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(objectUrl)
}

export async function saveApiDownload(
  result: DownloadResult,
  fallbackFilename = 'download',
  apiBaseUrl = '',
  path = true
): Promise<false | void> {
  if (result.contentType?.toLowerCase().includes('json')) {
    const payload = JSON.parse(await readBlobText(result.blob)) as { code?: number; msg?: string; data?: unknown }
    if (payload.code !== undefined && payload.code !== 1 && payload.code !== 200) {
      throw new Error(payload.msg || '下载失败')
    }
    if (
      payload.data &&
      typeof payload.data === 'object' &&
      'finished' in payload.data &&
      payload.data.finished === false
    ) {
      return false
    }
    const filePath =
      typeof payload.data === 'string'
        ? payload.data
        : payload.data && typeof payload.data === 'object' && 'zipUrl' in payload.data
          ? typeof payload.data.zipUrl === 'string'
            ? payload.data.zipUrl
            : ''
          : ''
    if (filePath) {
      const anchor = document.createElement('a')
      if (path) {
        anchor.href = resolveApiIVUSUrl(filePath, apiBaseUrl)
      } else {
        anchor.href = resolveApiAssetUrl(filePath, apiBaseUrl)
      }
      anchor.download = result.filename || filenameFromPath(filePath) || fallbackFilename
      anchor.style.display = 'none'
      document.body.appendChild(anchor)
      anchor.click()
      anchor.remove()
      return
    }
    throw new Error(payload.msg || '下载响应缺少文件地址')
  }
  saveDownload(result, fallbackFilename)
}
